import { render, staticRenderFns } from "./WColumns.vue?vue&type=template&id=3965ce0a&scoped=true&"
import script from "./wColumns.ts?vue&type=script&lang=ts&"
export * from "./wColumns.ts?vue&type=script&lang=ts&"
import style0 from "./WColumns.vue?vue&type=style&index=0&id=3965ce0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3965ce0a",
  null
  
)

export default component.exports